import { buildQueryString } from '../helpers/Utils';

class Geofences {
  /**
   * Constructs a new instance of this class
   *
   * @param api {API}
   */
  constructor(api) {
    this.api = api;
  }

  get(id) {
    return this.api.fetchJson('/api/geofences/get/' + id);
  }

  list(query) {
    query = query || {};
    const queryString = buildQueryString(query);

    return this.api.fetchJson('/api/geofences/' + queryString);
  }

  createOrUpdate(geofence) {
    const method = geofence._id ? 'PUT' : 'POST';

    return this.api.fetchJson('/api/geofences', {
      method,
      body: JSON.stringify(geofence),
    });
  }
}

export default Geofences;
